module.exports = __webpack_public_path__ + "5abaa0415d7df6b5308b34bbb7a07b8c.png";